import { render } from "./EventResourceModal.vue?vue&type=template&id=3b0186e3&scoped=true"
import script from "./EventResourceModal.vue?vue&type=script&lang=js"
export * from "./EventResourceModal.vue?vue&type=script&lang=js"

import "./EventResourceModal.vue?vue&type=style&index=0&id=3b0186e3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0186e3"]])

export default __exports__